var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 116,
    viewBox: "0 0 220 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_8062)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_931_8062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 220,
    height: 116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 0H0V116H220V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_931_8062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H220V116H0V0Z",
    fill: "#1A1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18H220V116H0V18Z",
    fill: "url(#paint0_radial_931_8062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V116H0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H220V18H197.834H78.3104H0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186 0.000137329C160.085 -24.8846 120 -19.5 93.5001 -0.500023C87.0382 4.133 82.0197 11.1716 78.3105 18.0001H197.834C194.704 11.2988 190.728 4.54029 186 0.000137329Z",
    fill: "#9DAFBC",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 33H167C168.061 33 169.078 33.4214 169.828 34.1716C170.579 34.9217 171 35.9391 171 37V96C171 97.0609 170.579 98.0783 169.828 98.8284C169.078 99.5786 168.061 100 167 100H102C100.939 100 99.9217 99.5786 99.1716 98.8284C98.4214 98.0783 98 97.0609 98 96V37C98 35.9391 98.4214 34.9217 99.1716 34.1716C99.9217 33.4214 100.939 33 102 33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 82H158C159.326 82 160.598 82.5268 161.536 83.4645C162.473 84.4021 163 85.6739 163 87C163 88.3261 162.473 89.5979 161.536 90.5355C160.598 91.4732 159.326 92 158 92H112C110.674 92 109.402 91.4732 108.464 90.5355C107.527 89.5979 107 88.3261 107 87C107 85.6739 107.527 84.4021 108.464 83.4645C109.402 82.5268 110.674 82 112 82Z",
    fill: "#42B6F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_931_8062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.5 70.8017) rotate(8.64667) scale(126.437 105.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85CAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147488,
    stopColor: "#85CAFB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217274,
    stopColor: "#365067",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441521,
    stopColor: "#0C0B11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_8062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.af3d817c.svg";
export { ForwardRef as ReactComponent };